/* eslint-disable */
import { $http } from '@/plugins/axios';
import { AxiosResponse } from 'axios';

export const notificationService = {
	getNotificationsByYear: (params: any): Promise<AxiosResponse> => {
		return $http.get('v1/org_admin/notices', {
			params,
		});
	},
	getNotificationsByYearForStaffs: (params: any): Promise<AxiosResponse> => {
		return $http.get('v1/org_admin/notices/staff_index', {
			params,
		});
	},
	getNotification: (id: string): Promise<AxiosResponse> => {
		return $http.get(`v1/org_admin/notices/${id}`);
	},
	getParentReadNotification: (id: string): Promise<AxiosResponse> => {
		return $http.get(
			`v1/org_admin/notices/${id}/students_with_parent_read`
		);
	},
	deleteNotification: (id: string): Promise<AxiosResponse> => {
		return $http.delete(`v1/org_admin/notices/${id}`);
	},
	sendNotification: (id: string): Promise<AxiosResponse> => {
		return $http.post(`v1/org_admin/notices/${id}/send`);
	},
	resendNotification: (id: string): Promise<AxiosResponse> => {
		return $http.post(`v1/org_admin/notices/${id}/resend`);
	},
	withdrawNotification: (id: string): Promise<AxiosResponse> => {
		return $http.post(`v1/accountant/notices/${id}/withdraw`);
	},
	createNotification: (data: any): Promise<AxiosResponse> => {
		return $http.post('v1/org_admin/notices', data);
	},
	updateNotification: (id: string, data: any): Promise<AxiosResponse> => {
		return $http.put(`v1/org_admin/notices/${id}`, data);
	},
	getFeeNotificationsByMonth: (params: any): Promise<AxiosResponse> => {
		return $http.get('v1/accountant/tuition_notices', {
			params,
		});
	},
	getFeeNotificationsId: (): Promise<AxiosResponse> => {
		return $http.post('v1/accountant/tuition_notices');
	},
	createFeeNotification: (data: any): Promise<AxiosResponse> => {
		return $http.post('v1/accountant/tuition_notices', data);
	},
	updateFeeNotification: (id: string, data: any): Promise<AxiosResponse> => {
		return $http.put(`v1/accountant/tuition_notices/notices/${id}`, data);
	},
	getFeeNotification: (id: string): Promise<AxiosResponse> => {
		return $http.get(`v1/accountant/tuition_notices/notices/${id}`);
	},
	sendFeeNotification: (params: any): Promise<AxiosResponse> => {
		return $http.post(`v1/accountant/tuition_notices`,
			params
		);
	},
	editFeeNotification: (template_id: string, tuition_id: string, params: any): Promise<AxiosResponse> => {
		return $http.put(`v1/accountant/tuition_templates/${template_id}/student_tuition_from_templates/${tuition_id}`,
			params
		);
	},
	sendSaveFeeNotification: (id: string): Promise<AxiosResponse> => {
		return $http.post(`v1/accountant/tuition_notices/notices/${id}/send`);
	},
	reSendFeeNotification: (id: string): Promise<AxiosResponse> => {
		return $http.post(`v1/accountant/tuition_notices/${id}/resend`);
	},
	markPaid: (data: any): Promise<AxiosResponse> => {
		return $http.put(`v1/accountant/tuitions/mark_as_paid`, data);
	},
	historySendFeeNotification: (id: string): Promise<AxiosResponse> => {
		return $http.get(`v1/accountant/tuition_notices/${id}/resend_history`);
	},
	deleteFeeNotification: (id: string): Promise<AxiosResponse> => {
		return $http.delete(`v1/accountant/tuition_notices/notices/${id}`);
	},
};
